import { useRouter } from 'next/router'
import Script from 'next/script'
import React, { useCallback, useEffect } from 'react'

import useAuthStore, { getAuthUser } from 'app/store/auth.store'
import { hasGuestStatus } from 'app/utils/helpers/user.helpers'

import * as gtag from '~/utils/helpers/gtag.helpers'

const GTMScript = () => {
  const router = useRouter()
  const user = useAuthStore(getAuthUser)
  const isGuestUser = hasGuestStatus(user?.status)

  const handleRouteChange = useCallback(
    (url: string) => {
      const userId = isGuestUser ? undefined : user?.id

      gtag.pageview(url, userId)
    },
    [user?.id]
  )

  useEffect(() => {
    if (!router?.events) return

    router.events.off('routeChangeComplete', handleRouteChange)

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [handleRouteChange, router?.events])

  return (
    <>
      <Script
        id="next-gtm"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${gtag.GTM_ID}');
          `
        }}
      />
    </>
  )
}

export default GTMScript
